import { FormInstance } from 'antd';
import { PurchaseTypeOption } from '../../api/marketplace';

export interface PricingDetail {
  price: number;
  description: string;
}

export interface BulkWearableItem {
  wearableId: string;
  itemId: string;
  itemName: string;
  description: string;
  image: string;
  wearableType: string;
  material: string;
  style: string;
  fabric: string;
  tags: string;
  pricingModel: string[];
  pricingDetails: { [key: string]: PricingDetail };
}

export interface AddItemFormData {
  itemType: string;
  itemName: string;
  industry: string;
  language: string;
  type: string;
  tags: string;
  description: string;
  wearableType?: string;
  material?: string;
  style?: string;
  fabric?: string;
  version?: string;
  note?: string;
  content?: string;
  marketplaceId?: string;
  lastVerifiedAt?: string;
  lastVerifiedBy?: string;
  encryptionStandard?: string;
  encriptionAtributes?: string;
  itemUpload: any[];
  thumbnail: any[];
  videoDemo: any[];
  iconUrl?: string;
  terms_of_use: string;
  privacy_policy: string;
  pricingModel: string[];
  pricingDetails: { [key: string]: PricingDetail };
  supportedInterfaces: string[];
  agentName: string;
  agentType: string;
  agentDescription: string;
  agentSkills: string;
  agentAvailability: string;
}

export interface PricingOption {
  value: string;
  id: string;
  label: string;
  desc: string;
  allowMultiple: boolean;
}

export const LABEL_MAPS = {
  itemType: {
    avatar: 'Avatar',
    skill: 'Skill',
    agent: 'Agent',
    model: 'Model',
    data: 'Data',
    wearables: 'Wearables',
    workflow: 'Workflow',
  } as { [key: string]: string },

  industry: {
    general: 'General',
    healthcare: 'Healthcare',
    finance: 'Finance',
    ecommerce: 'E-commerce',
    insurance: 'Insurance',
    retail: 'Retail',
  } as { [key: string]: string },

  language: {
    'english-us': 'English (US)',
    'english-uk': 'English (UK)',
  } as { [key: string]: string },

  type: {
    service: 'Service',
    product: 'Product',
    tool: 'Tool',
  } as { [key: string]: string },

  pricingModel: {
    renting: 'Monthly Subscription',
    purchasing: 'One-time Purchase',
    payPerUse: 'Pay-Per Usage',
    free: 'Freemium',
    freemium: 'Freemium',
  } as { [key: string]: string },

  interface: {
    chat: 'Chat',
    voice: 'Voice',
    api: 'API',
  } as { [key: string]: string },
};

export const getLabel = (value: string, map: { [key: string]: string }): string => {
  return map[value] || value;
};
